import { useEffect, useState, type SetStateAction } from "react";
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { VolumesGeneralFilters } from "../Volumes/VolumesGeneralFilters";
import { UserWithdrawsPerLocation } from "../../components/charts/UserWithdrawsPerLocation.chart";
import { UsersWithMoneyInWallet } from "../../components/charts/UsersWithMoneyInWallet.chart";
import { WalletDonationsCumulative } from "../../components/charts/WalletDonationsCumulative.chart";
import { DonationsPerCommunity } from "../../components/charts/DonationsPerCommunity.chart";
import { useWithdraws } from "../../store/useWithdraws";
import { WalletStatsCards } from "../../components/wallet/WalletStatsCards";
import { PrimaryButton } from "../../components";
import WalletExportModal from "./WalletExportModal";

const PaymentsScreen = () => {
  const [filterType, setFilterType] = useState<"location" | "city">("location");
  const [filterPlaces, setFilterPlaces] = useState<string[]>([]);
  const [sequenceStep, setSequenceStep] = useState(0);
  const [isExportOpen, setIsExportOpen] = useState(false);
  const { getWalletStats, walletStats, isWalletStatsLoading } = useWithdraws();

  /** When general filter changes, run chart fetches in sequence (step 0 → 1 → …) */
  useEffect(() => {
    setSequenceStep(0);
  }, [filterType, filterPlaces]);

  useEffect(() => {
    getWalletStats();
  }, [getWalletStats]);

  /** Reset sequence synchronously when user changes filter type so charts see step=0 on first render */
  const setFilterTypeWithReset = (v: SetStateAction<"location" | "city">) => {
    setSequenceStep(0);
    setFilterType(v);
  };

  return (
    <main>
      <div className="flex items-center justify-end mb-2">
        <PrimaryButton
          label="Download wallet data"
          onClick={() => setIsExportOpen(true)}
          className="!bg-droppie-oranje mb-2 !border-droppie-oranje active:!bg-droppie-oranje-dark h-8 flex items-center justify-center"
        />
      </div>
      <WalletStatsCards
        walletStats={walletStats}
        isLoading={isWalletStatsLoading}
      />

      <WalletExportModal
        isOpen={isExportOpen}
        onClose={() => setIsExportOpen(false)}
      />

      <VolumesGeneralFilters
        filterType={filterType}
        setFilterType={setFilterTypeWithReset}
        filterPlaces={filterPlaces}
        setFilterPlaces={setFilterPlaces}
      />
      <UserWithdrawsPerLocation
        filterType={filterType}
        filterPlaces={filterPlaces}
        sequenceStep={sequenceStep}
        setSequenceStep={setSequenceStep}
        sequenceStepIndex={0}
      />
      <UsersWithMoneyInWallet
        filterType={filterType}
        filterPlaces={filterPlaces}
        sequenceStep={sequenceStep}
        setSequenceStep={setSequenceStep}
        sequenceStepIndex={1}
      />
      <WalletDonationsCumulative
        mode="perPeriod"
        filterType={filterType}
        filterPlaces={filterPlaces}
      />
      <DonationsPerCommunity />
    </main>
  );
};

export default withProtectedRoute(PaymentsScreen);
